import React from 'react'
import { Tooltip } from 'src/components/Reusable/Tooltip'

export const truncate = ({
  text,
  chars = 20,
}: {
  text: string
  chars?: number
}): string =>
  text.length > chars ? `${text.substring(0, chars - 3)}...` : text

export const formatEvidenceCaption = (
  caption: string,
  isAutomated: boolean,
  truncate?: boolean,
  isViaRequest?: boolean,
  isControlShowPage?: boolean,
): JSX.Element | string => {
  const cleanedCaption = isAutomated ? caption.replaceAll('--', '-') : caption
  const formattedCaption = isControlShowPage
    ? cleanedCaption + (isViaRequest ? ' - via Request' : '')
    : cleanedCaption
  return truncate ? (
    <Tooltip
      id={formattedCaption}
      placement="top-end"
      tooltipBody={formattedCaption}
    >
      <>{`${formattedCaption.slice(0, 50)}...`}</>
    </Tooltip>
  ) : (
    formattedCaption
  )
}
